import { FC, memo } from 'react';

import FieldEntry from '../../../../../components/FieldEntry';
import FieldEntryWrapper from '../../../../../components/FieldEntryWrapper/FieldEntryWrapper';
import PreviewSection from '../../../../../components/previewSection/PreviewSection';
import SectionSeparator from '../../../../../components/SectionSeparator/SectionSeparator';
import { messages } from './ContactInformationSection.messages';
import { Root } from './ContactInformationSection.styles';
import { ContactInformationSectionProps } from './ContactInformationSection.types';

const ContactInformationSection: FC<ContactInformationSectionProps> = memo((props) => {
    const { contactData } = props;

    const hasFilledValue =
        contactData.phone || contactData.fax || contactData.mobile || contactData.emailAddress || contactData.webSite;

    if (!hasFilledValue) {
        return null;
    }

    return (
        <>
            <PreviewSection header={messages.header}>
                <Root>
                    {contactData.phone && (
                        <FieldEntryWrapper>
                            <FieldEntry title={messages.phone} value={contactData.phone} />
                        </FieldEntryWrapper>
                    )}

                    {contactData.fax && (
                        <FieldEntryWrapper>
                            <FieldEntry title={messages.fax} value={contactData.fax} />
                        </FieldEntryWrapper>
                    )}

                    {contactData.mobile && (
                        <FieldEntryWrapper>
                            <FieldEntry title={messages.mobile} value={contactData.mobile} />
                        </FieldEntryWrapper>
                    )}

                    {contactData.emailAddress && (
                        <FieldEntryWrapper>
                            <FieldEntry title={messages.email} value={contactData.emailAddress} />
                        </FieldEntryWrapper>
                    )}

                    {contactData.webSite && (
                        <FieldEntryWrapper>
                            <FieldEntry title={messages.website} value={contactData.webSite} />
                        </FieldEntryWrapper>
                    )}
                </Root>
            </PreviewSection>

            <SectionSeparator />
        </>
    );
});

export default ContactInformationSection;
